"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAllPropsWithValues = void 0;
var lodash_1 = require("lodash");
var extractPropsAsTests_1 = require("./extractPropsAsTests");
var hasAllPropsWithValues = function (obj) { return function () {
    var props = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        props[_i] = arguments[_i];
    }
    return lodash_1.flow(function (p) { return extractPropsAsTests_1.extractPropsAsTests(obj).apply(void 0, p); }, // TS/lodash bollocks
    lodash_1.partialRight(lodash_1.filter, function (propTest) {
        return propTest.expectedValue !== undefined ?
            propTest.expectedValue === propTest.actualValue :
            propTest.actualValue;
    }), function (p) { return p.length === props.length; })(props);
}; };
exports.hasAllPropsWithValues = hasAllPropsWithValues;
//# sourceMappingURL=hasAllPropsWithValues.js.map